import React from "react";
import SummaryDetailWithIcon from "../shared/groups/SummaryDetailWithIcon";
import cardStyles from "../../assets/css/modules/myprofile/myprofilecard.css";

export default props => (
  <SummaryDetailWithIcon
    iconSrc={props.iconSrc + " " + cardStyles.cardIcon}
    title={props.title}
    subTitle={props.subTitle}
    InfoText={props.InfoText}
    linkTo={props.linkTo}
    linkText={props.linkText}
    info={props.info}
    isUpdated={props.isUpdated}
    styles={cardStyles}
    linkMethod={props.linkMethod}
    isDisabled={props.isDisabled}
    isCrestDowntime={props.isCrestDowntime}
    featureFlagEP={props.featureFlagEP}
    IsFormat2={props.IsFormat2}
    IsHealthSelect={props.IsHealthSelect}
    IsOverageDependant={props.IsOverageDependant}
    id={props.id}
    MFATitle={props.MFATitle}
    MFAText={props.MFAText}
    isMyprofile ={props.isMyprofile}
  />
);
